// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__oCQkq","content":"Consent_content__37wqC","footer":"Consent_footer__1kFF_"};